// SUUMOSCOREモーダル
const ModalSuumoscore = {
  namespaced: true,

  state: {
    modal: false,
  },
  getters: {
    getModal: state => {
      return state.modal
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
  },
  actions: {
    async show({ commit }) {
      commit('setModal', true)
    },
    hide({ commit }) {
      commit('setModal', false)
    },
  },
}

export default ModalSuumoscore
